import { AfterViewInit, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AgenteClientService, TermsOfUse } from '@rsm/client/agente-client';
import { MessageService } from '@rsm/shared/message';

export interface TermsOfUseAcceptDialogData {
  term: TermsOfUse;
  subtitle?: string;
  acceptLabel?: string;
  agreementText?: string;
  readonly?: boolean;
}

@Component({
  selector: 'app-terms-of-use-accept-dialog',
  templateUrl: './terms-of-use-accept-dialog.component.html',
  styleUrls: ['./terms-of-use-accept-dialog.component.scss'],
})
export class TermsOfUseAcceptDialogComponent implements AfterViewInit {
  @ViewChild('contentBox') contentBox?: ElementRef<HTMLElement>;

  accepting = false;
  canAccept = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TermsOfUseAcceptDialogData,
    private dialogRef: MatDialogRef<TermsOfUseAcceptDialogComponent>,
    private agenteClientService: AgenteClientService,
    private messageService: MessageService
  ) {}

  get term(): TermsOfUse {
    return this.data.term;
  }

  get readonly(): boolean {
    return this.data.readonly === true;
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.updateCanAccept());
  }

  onContentScroll(): void {
    this.updateCanAccept();
  }

  accept(): void {
    if (this.readonly) {
      this.dialogRef.close(false);
      return;
    }

    if (this.accepting || !this.canAccept) {
      return;
    }

    this.accepting = true;
    this.agenteClientService.acceptActiveTermsOfUse(this.term.documentType).subscribe({
      next: () => {
        this.accepting = false;
        this.dialogRef.close(true);
      },
      error: (error) => {
        this.accepting = false;
        this.messageService.addMsgDanger(error);
      },
    });
  }

  close(): void {
    this.dialogRef.close(false);
  }

  private updateCanAccept(): void {
    const element = this.contentBox?.nativeElement;
    if (!element) {
      return;
    }
    const scrollEnd = element.scrollTop + element.clientHeight;
    this.canAccept = scrollEnd >= element.scrollHeight - 8;
  }
}
